import React from 'react';
import MigrateTab from '../MigrateTab';

export const COLUMN_HEADERS_DISABLED = [
    { key: 'email', label: 'Correo', value: 'email' },
    { key: 'feed_name', label: 'Feed', value: 'feed_name' },
    { key: 'total_rejections', label: 'Publicaciones Rechazadas', value: 'total_rejections' },
    { key: 'total_publications_active', label: 'Publicaciones Activas', value: 'total_publications_active' },
    { key: 'date_of_last_direct_publication', label: 'Fecha Última Publicación ', value: 'date_of_last_direct_publication' },
    { key: 'actions', label: 'Acciones', value: 'actions' },
];
const MigrateBaned = (props) => {
  return (
      <MigrateTab
          columnHeaders={COLUMN_HEADERS_DISABLED} 
          type="disabled"
          bannedUsers={props.bannedUsers}
          activeTab={props.activeTab}
      />
  );
}

export default MigrateBaned;
